import { render } from "./elecBoardContainer.vue?vue&type=template&id=0a5a45a2&scoped=true"
import script from "./elecBoardContainer.vue?vue&type=script&lang=js"
export * from "./elecBoardContainer.vue?vue&type=script&lang=js"

import "./elecBoardContainer.vue?vue&type=style&index=0&id=0a5a45a2&scoped=true&lang=css"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5a45a2"]])

export default __exports__